import { rawColors } from "./color";
import { CustomizableColors } from "./CustomizableColors";


export const joblifeColors:CustomizableColors = {

    primary:{
        light:"rgba(241,241,240, 1)",
        normal:"rgba(154,153,154, 1)",
        dark:"rgba(74,73,74, 1)"
    },

    secondary:"rgba(247,207,113, 1)",
    
    
    active: {
        default: { normal: rawColors.gray.dark, hover: rawColors.black },
        dark: { normal: rawColors.gray.dark, hover: rawColors.black }
    },

    mainNavigation:{
            
        background:"#3c0e10",
        backgroundSelected:"#592d2e",
        divider:"#592d2e",
        color:"white",
        colorSelected:"white"
    },

    button: {
        filled: {
            background: "#3c0f11",
            backgroundHover: "#592d2e"
        },
        outlined: {
            border: "#3c0f11",
            text: "#3c0f11",
            textHover: "white",
            backgroundHover: "#592d2e"
        },
        text: {
            text: "#3c0f11",
            textHover: "#592d2e",
            backgroundHover: "rgba(241,241,240, 1)"
        },
        light: {
            text: "#3c0f11",
            textHover: "#592d2e",
            background: "rgba(241,241,240, 1)",
            backgroundHover: "rgba(241,241,240, 1)"
        }
    },

    tabber: {
        border: rawColors.gray.normal,
        color: rawColors.gray.normal,
        colorSelected: "white",
        colorSelected2: "red",
        colorDisabled: rawColors.gray.light,
        backgroundSelected: "#3c0f11",
        backgroundHover: "#592d2e",
    }
}